import { render, staticRenderFns } from "./EditFodderModal.vue?vue&type=template&id=d394d7ce&lang=pug&"
import script from "./EditFodderModal.vue?vue&type=script&lang=js&"
export * from "./EditFodderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports